import { getAllAgentClients } from "../../utils/apiClient";

/**
 * Fetch all IB/agent clients.
 * Wraps the encrypted API helper and returns the decrypted payload when available.
 *
 * @param {object} params
 * @param {number} [params.page=1] - Page number (query param).
 * @param {number} [params.withDoc=1] - WITH_DOC flag sent in BODY.
 * @param {string|null} [params.search=null] - Optional SEARCH term.
 * @param {object} [params.options={}] - Optional options forwarded to apiClient.
 * @returns {Promise<any>} Decrypted response data (fallback to raw data/response).
 */
export const fetchAgentClients = async ({
  page = 1,
  withDoc = 1,
  search = null,
  showTree = undefined,
  userId = undefined,
  options = {},
} = {}) => {
  const response = await getAllAgentClients(
    page,
    withDoc,
    search,
    showTree,
    userId,
    options
  );

  // Prefer decryptedData from postEncryptedJson helper when available
  if (response && response.decryptedData) {
    return response.decryptedData;
  }

  // Fallbacks
  if (response && response.data) {
    return response.data;
  }

  return response;
};

export default {
  fetchAgentClients,
};

